/**
 * Initialize all sub-modules
 */

/* eslint-disable */

jQuery(function($) {
	var helper = require('../commons/helper');
	
	var $form = $('.registration-form-container form');

	var modules = {
		form: require('./form'),
		username: require('./username'),
		password: require('./password'),
		countryRegion: window.params.zaAddress ? require('./countryRegionZA'):require('./countryRegion'),
		account: require('./account'),
		accountCustomerShowHide: require('./accountCustomerShowHide'),
		allMarketsShowHide: require('./allMarketsShowHide'),
		excludedMarketsShowHide: require('./excludedMarketsShowHide'),
		tracking: require('./tracking')
	};

	// params is supposed to be defined in the page.
	helper.initPage({
		$form: $form, 
		modules: modules
	});
});




//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/registration.js
// module id = 253
// module chunks = 4